export enum ROLES {
  MOEVE_ADMIN = 'MOEVE_ADMIN',
  MANAGER = 'MANAGER',
  USER = 'USER',
}
